import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
// import PropTypes from 'prop-types'
import { DropdownStyled } from './styled';
import ReactDropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import { Icons } from 'components'

const Dropdown = ({
  theme_standard,
  theme_normal,
  label,
  options,
  value,
  onChange,
  onChaneCustom,
  placeholder,
  errors,
  disabled,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
    theme_normal: theme_normal,
  });
  const rootRef = useRef(null);

  // ปิดเมนูเมื่อกด/แตะนอก dropdown
  // react-dropdown ปิดเองด้วย document "click" แต่ในบางกรณี (เปิดอีกตัวซ้อน / element ที่หยุด
  // การ bubble ของ click) เมนูค้างเปิดไว้ จึงฟัง mousedown/touchstart แบบ capture ที่ document เอง
  // แล้วสั่ง toggle ผ่าน control ของ react-dropdown (library ไม่มี prop ควบคุมสถานะเปิด/ปิด)
  useEffect(() => {
    const handleOutside = (event) => {
      const root = rootRef.current;
      if (!root || root.contains(event.target)) return;
      const openRoot = root.querySelector('.Dropdown-root.is-open');
      if (!openRoot) return;
      const control = openRoot.querySelector('.Dropdown-control');
      if (control) {
        control.dispatchEvent(
          new MouseEvent('mousedown', { bubbles: true, cancelable: true, button: 0 })
        );
      }
    };
    document.addEventListener('mousedown', handleOutside, true);
    document.addEventListener('touchstart', handleOutside, true);
    return () => {
      document.removeEventListener('mousedown', handleOutside, true);
      document.removeEventListener('touchstart', handleOutside, true);
    };
  }, []);

  return (
    <DropdownStyled ref={rootRef}>
      <div className={customClass}>
        {label && <div className="label">{label}</div>}
        {/* ส่งไอคอนลูกศรเองทั้งสถานะเปิดและปิด react-dropdown จึงไม่ใส่ arrowClassName ให้
            ตำแหน่งลูกศรถูกจัดที่ .Dropdown-arrow-wrapper ใน styled.js

            height ต้องได้สัดส่วนกับ viewBox (21.81 x 13.274) ถ้าส่งแต่ width
            จะเหลือขอบว่างบน-ล่างในกล่อง svg ทำให้ดูเหมือนลูกศรไม่อยู่กึ่งกลาง
            13 x (13.274 / 21.81) = 7.91 */}
        <ReactDropdown
          controlClassName="input_dropdown"
          placeholderClassName="myPlaceholderClassName"
          disabled={disabled}
          options={options}
          onChange={(e) => {
            onChange(e.value);
            onChaneCustom && onChaneCustom(e.value);
          }}
          value={value}
          placeholder={placeholder}
          arrowClosed={<div className='arrow'><Icons.ArrowDropdown color='#dcdcdc' width='13px' height='7.91px' /></div>}
          arrowOpen={<div className='arrow'><Icons.ArrowDropdown translate="21.81" rotate="90" color='#dcdcdc' width='13px' height='7.91px' /></div>}
        />
        {errors && <div className="errors">{errors}</div>}
      </div>
    </DropdownStyled>
  );
};

Dropdown.propTypes = {};

export default Dropdown;
